import React from "react";
import { AppBar, Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const FullWidthTab = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Full width
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          The variant="fullWidth" prop should be used for smaller views. This
          demo also uses react-swipeable-views to animate the Tab transition,
          and allowing tabs to be swiped on touch devices.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <AppBar position=\"static\">\n" +
              "                <Tabs\n" +
              "                  value={value}\n" +
              "                  onChange={handleChange}\n" +
              "                  indicatorColor=\"secondary\"\n" +
              "                  textColor=\"inherit\"\n" +
              "                  variant=\"fullWidth\"\n" +
              "                  aria-label=\"full width tabs example\"\n" +
              "                >\n" +
              "                  <Tab label=\"Item One\" {...a11yProps(0)} />\n" +
              "                  <Tab label=\"Item Two\" {...a11yProps(1)} />\n" +
              "                  <Tab label=\"Item Three\" {...a11yProps(2)} />\n" +
              "                </Tabs>\n" +
              "              </AppBar>\n" +
              "              <TabPanel value={value} index={0}>\n" +
              "                Item One\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={1}>\n" +
              "                Item Two\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={2}>\n" +
              "                Item Three\n" +
              "              </TabPanel>"}>
            <Box sx={{ width: "100%" }}>
              <AppBar position="static">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Item One" {...a11yProps(0)} />
                  <Tab label="Item Two" {...a11yProps(1)} />
                  <Tab label="Item Three" {...a11yProps(2)} />
                </Tabs>
              </AppBar>
              <TabPanel value={value} index={0}>
                Item One
              </TabPanel>
              <TabPanel value={value} index={1}>
                Item Two
              </TabPanel>
              <TabPanel value={value} index={2}>
                Item Three
              </TabPanel>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default FullWidthTab;
